module.exports = __webpack_public_path__ + "img/share.3c204286.svg";